
export default {
  init() {
    const setInfo = function (index) {
      const slide = $(`#carousel a[data-index="${index}"]`)
      let categoryElements = ''
      slide.attr('data-categories').split(',').forEach((str) => {
        categoryElements += `<span>${str}</span>`
      })
      $('#carouselInfo .categories').html(categoryElements)
      $('#carouselInfo .date').text(slide.attr('data-date'))
      $('#carouselInfo .title').text(slide.attr('data-title'))
      $('#carouselInfo').attr('href', slide.attr('href'))
    }
    $('#carousel').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      infinite: true,
      dots: true,
      arrows: false,
      draggable: false,
      fade: true,
      cssEase: 'ease-in-out'
    }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      setInfo(nextSlide)
    });
    setInfo(0) // 最初イベントが発火しないので、マニュアルで設定
  },
  beforeLeave() {
    // カルーセル破棄
    if ($('#carousel').hasClass('slick-initialized')) {
      $('#carousel').slick('destroy');
    }
  }
};
